import { render } from "./OtherMeasurements.vue?vue&type=template&id=90461e38"
import script from "./OtherMeasurements.vue?vue&type=script&lang=js"
export * from "./OtherMeasurements.vue?vue&type=script&lang=js"
script.render = render

export default script